<template>
  <v-container>
    <v-layout row class="text-xs-center">           
        <v-container style="position: relative;top: 13%;" class="text-xs-center">                      
            <h1>What would you like to do?</h1>
            <v-btn color="primary" @click="request()">Request for Immunity Passport</v-btn>
            <v-btn color="primary" @click="view()">View your Immunity Passport</v-btn>
        </v-container>  
    </v-layout>
  </v-container>
</template>

<script>
import EosService from '@/eosio/EosService';

export default {
  data() {
    return {
      pKey: '',
      eosio: null
    };
  },
  methods: {
    request: async function(){
      this.$router.push('immpass');
    },
    view: async function(){
      this.$router.push('view');
    }
  }
};
</script>